<template>
  <label :class="$style.wrapper" class="checkBox">
    <input :class="$style.input" type="checkbox" :disabled="disabled" @change="$emit('change', $event.target.checked)" :checked="checked"/>
    <span :class="$style.span"></span>
  </label>
</template>

<script>
export default {
  name: 'checkBox',
  props: {
    checked: Boolean,
    disabled: Boolean,
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
}
</script>

<style lang="scss" module>
  .wrapper {
    position: relative;
    line-height: 1;
    &:focus {
      outline: none;
    }
  }
  .span {
    position: relative;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.25);
    display: inline-block;
    &:after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background-color: white;
      visibility: hidden;
      @media #{$m-mobile} {
        top: 4px;
        left: 4px;
        height: 8px;
        width: 8px;
        transform: none;
      }
    }
    @media #{$m-tablet} {
      width: 16px;
      height: 16px;
    }
    @media #{$m-mobile} {
      width: 16px;
      height: 16px;
    }
  }
  .input {
    display: none;
    &:checked ~ span {
      background-color: $color-green;
      box-shadow: 0 0 0 0.2rem $color-green;
      &:after {
        visibility: visible;
      }
    }
    &:focus {
      outline: none;
    }
  }
</style>
